import CurrencyInput from "react-currency-input-field";
import Str from "../../../helpers/Str";
import {IInputCurrency} from "../../../types";

export default function InputCurrency({label, value, onChange, onBlur, className, error, required}: IInputCurrency){
    return(
        <div className={Str.tw(className, 'w-full flex flex-col gap-2')}>
            <label className={'font-semibold'}>{label} {(label && required) ? <span className='text-red-600'>*</span> : ''}</label>
            <CurrencyInput
                id="input-example"
                className={Str.tw(
                    'py-2 px-1',
                    'placeholder-[#939396]',
                    'border  rounded-md outline-none px-4 w-full',
                    'focus:border-2 transition '
                )}
                intlConfig={{ locale: 'pt-BR', currency: 'BRL' }}
                name="valor"
                value={value}
                decimalsLimit={2}
                onValueChange={(value, name) => onChange(value, name)}
                onBlur={onBlur}
            />
            {!!error?.length && <span className="text-red-600 ">{error}</span>}
        </div>
    )
}